/* ============ Global leaderboard via Firebase Realtime Database ============
   Plain REST (fetch) — no SDK needed. Each DEVICE owns exactly one entry,
   keyed by an anonymous device id, so only one name can ever be submitted
   per device; changing your name just renames that single entry. */

import { loadPrizes, isTrophy, isCoin, COIN_VALUE } from "./prizes.js";
import { getName } from "./profile.js";

const DB = "https://carnival-dk-default-rtdb.europe-west1.firebasedatabase.app";
const DEV_KEY = "carnival.device";

export function deviceId() {
  try {
    let id = localStorage.getItem(DEV_KEY);
    if (!id) {
      id = "d" + Date.now().toString(36) + Math.random().toString(36).slice(2, 10);
      localStorage.setItem(DEV_KEY, id);
    }
    return id;
  } catch { return "d-anon"; }
}

/* Lifetime totals for this device's player: ALL prizes in the local
   collection count, regardless of the name they were won under — one player
   per device, so renaming must never reset the leaderboard. */
export function myTotals() {
  const name = getName();
  const all = loadPrizes();
  const trophies = all.filter(isTrophy).length;
  const coins = all.filter(isCoin).length;
  const plush = all.length - trophies - coins;
  // 1 guldmønt = COIN_VALUE tøjdyr: et byt i Bamsebørsen ændrer ALDRIG totalen
  return { name, trophies, plush, coins, total: trophies + plush + coins * COIN_VALUE };
}

/* Push this device's single entry. Fire-and-forget safe: never throws. */
export async function syncScore() {
  const s = myTotals();
  if (!s.name || s.total === 0) return false;   // nothing to put on the board yet
  try {
    const r = await fetch(`${DB}/leaderboard/${deviceId()}.json`, {
      method: "PUT",
      body: JSON.stringify({ ...s, updatedAt: Date.now() }),
    });
    return r.ok;
  } catch { return false; }
}

/* All entries, sorted: total desc, trophies break ties. */
export async function fetchBoard() {
  const r = await fetch(`${DB}/leaderboard.json`);
  if (!r.ok) throw new Error("board fetch failed");
  const data = (await r.json()) || {};
  return Object.entries(data)
    .map(([id, e]) => ({ id, name: e.name, trophies: e.trophies || 0, plush: e.plush || 0, coins: e.coins || 0, total: e.total || 0 }))
    .sort((a, b) => b.total - a.total || b.trophies - a.trophies || a.name.localeCompare(b.name));
}
